import { defineWebModule } from '@clientline/contracts/web-module';

/**
 * Вебманіфест демо-модуля (module-contract.md, розд. 5.8): лише дані й ліниві завантажувачі.
 * Оболонка знаходить його сама під час збірки; React і код компонентів вантажаться лише тоді,
 * коли внесок потрібен (картка демо-задачі, запуск команди).
 */
export default defineWebModule({
  id: 'demo',
  nav: [
    {
      id: 'demo.tasks',
      label: 'i18n:nav.tasks',
      route: '/l/demo_task.mine',
      permission: 'demo_task.read',
      icon: 'task',
    },
  ],
  slots: {
    'record.panels': [
      {
        id: 'demo.deadline',
        label: 'i18n:panel.deadline',
        when: { entity: 'demo_task' },
        load: () => import('./deadline-panel.tsx'),
      },
    ],
  },
  commands: [
    {
      id: 'demo.complete',
      label: 'i18n:command.complete',
      keywords: ['i18n:command.complete.keywords'],
      scope: 'record',
      when: { entity: 'demo_task' },
      permission: 'demo.complete',
      keys: { code: 'KeyD' },
      run: () => import('./complete.ts'),
    },
  ],
});
